window.dataLayer = window.dataLayer || [];

(() => {
  class DiageoDatalayerQueue {
    constructor() {
      /**
       * @type {any[]}
       */
      this.queue = [];
      this.formatters = Object.create(null);
    }

    /**
     * @param {DataLayerEvent} e
     */
    applyFormatter(e) {
      if (!e?.event) return;

      const formatter = this.formatters[e.event];
      if (!formatter) return e;

      return formatter({ eventObj: e.data });
    }

    /**
     * @param {DataLayerEvent} e
     */
    push(e) {
      this.queue.push(e);
      this.processQueue();
    }

    processQueue() {
      if (window.gtmId && !window.dataLayer.some((e) => e.event == 'gtm.js')) {
        return;
      }

      if (window.dataLayer.some((e) => e.event == 'page_view')) {
        this.flushAll();
        return;
      }

      const pageViewEvent = this.queue.find((e) => e.event == 'page_viewed');
      if (pageViewEvent) {
        this.sendEvent(pageViewEvent);
        this.flushAll();
      }
    }

    flushAll() {
      this.queue.forEach((e) => this.sendEvent(e));
      this.queue = [];
    }

    /**
     * @param {DataLayerEvent} e
     */
    sendEvent(e) {
      if (!e?.event) return;

      const formatedEvent = this.applyFormatter(e);
      if (formatedEvent) {
        this.queue = this.queue.filter((_e) => _e.event !== e.event);
        window.dataLayer.push(formatedEvent);
      }
    }
  }

  const dataLayerQueue = new DiageoDatalayerQueue();

  const originalPush = window.dataLayer.push;

  window.dataLayer.push = function (...args) {
    dataLayerQueue.processQueue();
    return originalPush.apply(this, args);
  };

  window.dataLayerFormatters = (formattersPatch) => {
    if (formattersPatch && typeof formattersPatch === 'object') {
      Object.assign(dataLayerQueue.formatters, formattersPatch);
    }
  };

  window.dataLayerPush = (ctx) => {
    dataLayerQueue.push({ ...ctx });
  };

  window.addEventListener('message', function (e) {
    if (e.data?.source !== 'shopify-pixel' && e.origin == null) return;
    dataLayerQueue.push({ ...e.data });
  });

  document.querySelector('cart-drawer-component')?.addEventListener('dialog:open', async (e) => {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    if (!cart) return;

    window.dataLayerPush({
      event: 'cart_drawer_viewed',
      data: {
        timestamp: new Date().toISOString(),
        data: {
          cart: cart,
        },
      },
    });
  });

  document.querySelectorAll('#ResultsList product-card').forEach((/** @type {HTMLElement} */ productCard) => {
    const id = productCard.dataset.productId;

    productCard.querySelectorAll('a').forEach((link) => {
      const getSelectedItem = (
        /** @type {string | null} */ collectionViewedData,
        /** @type {string | undefined} */ id
      ) => {
        if (!collectionViewedData) return;

        const parsedData = JSON.parse(collectionViewedData);

        const items = parsedData?.ecommerce?.items;
        if (!items) return;

        for (const item of items) {
          if (item.id === id) {
            return {
              item: item,
              currency: parsedData?.ecommerce?.currency || 'undefined',
              value: item?.price || 'undefined',
            };
          }
        }
      };

      link.addEventListener('click', () => {
        const collectionViewedData = localStorage.getItem('lastViewedCollectionData');

        const { item, currency, value } = getSelectedItem(collectionViewedData, id) || {};

        window.dataLayerPush({
          event: 'collection_selected_item',
          data: {
            timestamp: new Date().toISOString(),
            data: {
              payload: {
                currency: currency || 'undefined',
                value: value || 'undefined',
                item: item || 'undefined',
              },
            },
          },
        });
      });
    });
  });

  /** @type {Object.<string, any>} */
  const globalEventsConfig = (() => {
    const jsonNode = document.querySelector(`script[type="application/json"]#DataLayerGlobalEventsConfigJSON`);
    if (!jsonNode) return;

    const textContent = jsonNode.textContent.trim();
    if (!textContent) return;

    try {
      return JSON.parse(textContent);
    } catch (error) {
      console.error(error);
      return;
    }
  })();

  if (!globalEventsConfig) {
    console.error('Global events config for data layer is not defined');
    return;
  }

  if (globalEventsConfig.outboundClickEnabled) {
    document.addEventListener(
      'click',
      function (e) {
        /** @type {HTMLElement | null} */
        const target = e.target instanceof HTMLElement ? e.target : null;
        /** @type {HTMLAnchorElement | null | undefined} */
        const link = target?.closest('a[href]');
        if (!link) return;

        let outboundLinkType;
        if (target?.closest('nav')) {
          outboundLinkType = 'Navigation';
        } else if (target?.closest('footer')) {
          outboundLinkType = 'Footer';
        } else {
          outboundLinkType = 'Body';
        }

        try {
          const url = new URL(link.href);
          if (url.host !== window.location.host) {
            window.dataLayerPush({
              event: 'outbound_click',
              data: {
                timestamp: new Date().toISOString(),
                data: {
                  linkName: link.textContent.trim(),
                  linkUrl: link.href,
                  outboundLinkType,
                },
              },
            });
          }
        } catch {}
      },
      true
    );
  }

  if (globalEventsConfig.navigationClickEnabled) {
    if (!globalEventsConfig.navigationClickSelector) return;

    document.querySelectorAll(globalEventsConfig.navigationClickSelector).forEach(
      /** @param {HTMLLinkElement} navigationLink */ (navigationLink) => {
        navigationLink.addEventListener('click', () => {
          const target = new URL(navigationLink.href);
          const tagetHost = target.host;

          if (tagetHost != window.location.host) return;

          const targetPathname = target.pathname?.split('/')[1] || 'index';

          /** @type {Object.<string, any>} */
          const globalValues = (() => {
            const jsonNode = document.querySelector(`script[type="application/json"]#DataLayerGlobalValuesJSON`);
            if (!jsonNode) return;

            const textContent = jsonNode.textContent.trim();
            if (!textContent) return;

            try {
              return JSON.parse(textContent);
            } catch (error) {
              console.error(error);
              return;
            }
          })();

          const JOURNEY_TYPE_MAP = JSON.parse(globalValues.journeyTypeMap);
          const NAVIGATION_TYPE_MAP = JSON.parse(globalValues.navigationTypeMap);

          const getTypeFromMap = (/** @type {Object.<string, any>} */ map, /** @type {string} */ targetPathname) => {
            for (const pageType of Object.keys(map)) {
              const pathnames = map[pageType].split(',');
              if (pathnames.includes(targetPathname)) {
                return pageType;
              }
            }
          };

          window.dataLayerPush({
            event: 'navigation_click',
            data: {
              timestamp: new Date().toISOString(),
              data: {
                journeyType: getTypeFromMap(JOURNEY_TYPE_MAP, targetPathname) || 'Content',
                navigationType: getTypeFromMap(NAVIGATION_TYPE_MAP, targetPathname) || 'Content',
                interactionName: navigationLink.textContent.trim() || 'undefined',
              },
            },
          });
        });
      }
    );
  }

  if (globalEventsConfig.scrollEnabled) {
    /** @type {Object.<string, boolean>} */
    const scrollMilestones = {
      '25%': false,
      '50%': false,
      '75%': false,
      '100%': false,
    };

    function getScrollPercentage() {
      const scrollTop = window.scrollY || window.pageYOffset;

      const docHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      );

      const winHeight = window.innerHeight;
      const scrollable = docHeight - winHeight;

      if (scrollable <= 0) return 100;

      return Math.round((scrollTop / scrollable) * 100);
    }

    function handleScroll() {
      const percentage = getScrollPercentage();

      Object.keys(scrollMilestones).forEach((milestone) => {
        if (!scrollMilestones[milestone] && percentage >= Number.parseInt(milestone)) {
          scrollMilestones[milestone] = true;
          window.dataLayerPush({
            event: 'scroll',
            data: {
              timestamp: new Date().toISOString(),
              data: {
                scrollPercentage: milestone,
              },
            },
          });
        }
      });
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
  }
})();
